import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/asitesLogoDL.webp";


const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const handleToggle = () => setToggle(!toggle);
  const [activeTab, setActiveTab] = useState("home");
  const location = useLocation();
  const pathname = location.pathname;

  const [scrolled, setScrolled] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    if (pathname === "/") {
      setActiveTab("home");
    } else if (pathname === "/produktet") {
      setActiveTab("produktet");
    } else if (pathname === "/rreth-nesh") {
      setActiveTab("rreth-nesh");
    } else if (pathname === "/kontakti") {
      setActiveTab("kontakti");
    }
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Handle transparent to background color
      if (currentScrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }

      // Handle hiding navbar when scrolling up
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setShowNavbar(false); // scrolling down, hide navbar
      } else {
        setShowNavbar(true); // scrolling up, show navbar
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  return (
    <Container scrolled={scrolled} showNavbar={showNavbar}>
      <Link to={"/"} className="link-styles">
        <img className="logo" src={logo} alt="" decoding="async" />
      </Link>
      <ul
        onClick={handleToggle}
        className={toggle ? "nav-menu active" : "nav-menu"}
      >
        <Link to={"/"} className="link-styles">
          <li className={activeTab === "home" ? "activeTab" : "nonActive"}>
            Home
          </li>
        </Link>
        <Link to={"/services"} className="link-styles">
          <li className={activeTab === "services" ? "activeTab" : "nonActive"}>
            Services
          </li>
        </Link>
        <Link to={"/about-us"} className="link-styles">
          <li className={activeTab === "about-us" ? "activeTab" : "nonActive"}>
            About Us
          </li>
        </Link>
        <Link to={"/contact"} className="link-styles">
          <button
            className={activeTab === "contact" ? "activeTab" : "nonActive"}
          >
            Contact
          </button>
        </Link>
        {/* <FaCartShopping className="icon" /> */}
        {/* <LanguageSelector /> */}
      </ul>
      <div className="mobile-menu" onClick={handleToggle}>
        {toggle ? <FaTimes className="icon" /> : <FaBars className="icon" />}
      </div>
    </Container>
  );
};

const Container = styled.div`
  backdrop-filter: ${({ scrolled }) => (scrolled ? "blur(7px)" : "none")};
  background: ${({ scrolled }) => (scrolled ? "#08040c78" : "transparent")};
  position: fixed;
  top: ${({ showNavbar }) => (showNavbar ? "0" : "-100px")};
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1% 10%;
  width: 100%;
  height: 8%;
  z-index: 100;
  transition:
    top 0.3s ease,
    background-color 0.3s ease,
    backdrop-filter 0.3s ease;
  box-sizing: border-box;
  z-index: 9999999999;

  .logo {
    height: 45px;
    /* margin-top: 7px; */
  }
  .nav-menu {
    display: flex;
    gap: 37px;
    list-style: none;
    align-items: center;
    li {
      color: #d6d6d6;
      font-weight: 300;
      transition: 0.3s;
      cursor: pointer;
      white-space: nowrap;
      :hover {
        color: var(--fontPrimaryColor);
      }
    }
    .icon {
      color: #e04c0c;
      font-size: 2em;
    }
    button {
      background: #9281dd;
      border: none;
      color: white;
      padding: 7px 24px;
      font-size: 18px;
      border-radius: 20px;
      font-family: "Poppins", cursive;
      cursor: pointer;
      transition: 0.4s;
      &:hover {
        box-shadow: 0 0 14px 2px var(--shadowColor);
      }
    }
    .activeTab {
      font-weight: 600;
      color: var(--primaryColor);
    }
  }
  .mobile-menu {
    position: absolute;
    color: #383232;
    right: 5%;
    font-size: 24px;
    cursor: pointer;
    transition: 0.3s;
    display: none;
    margin-top: 7px;
    :hover {
      transform: scale(1.1);
    }
  }
  @media (max-width: 1000px) {
    .nav-menu {
      background: #2b2547;
      width: 90%;
      height: 100vh;
      display: flex;
      flex-direction: column;
      padding: 10%;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: 0%;
      right: -100%;
      transition: 0.3s;
      z-index: 99;
      border-left: 1px solid #9281dd li {
        color: white;
      }
      .activeTab {
        color: white;
      }
    }
    .mobile-menu {
      display: block;
      z-index: 99;
      color: white;
    }
    .nav-menu.active {
      right: 0%;
      color: white;
    }
  }
  @media (max-width: 670px) {
    height: 70px;
    .logo {
      width: 100px;
      height: auto;
    }
  }
  @media (max-width: 370px) {
    .nav-menu {
      width: 98%;
    }
  }
`;

export default Navbar;
